import React from 'react';
import Card from '../../components/ui/Card/Card';
import Skeleton from '../../components/ui/Skeleton/Skeleton';
import styles from './Users.module.css';

const UsersSkeleton: React.FC = () => (
  <div className={styles.page}>
    <div className={styles.statGrid}>
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className={styles.statCard}>
          <Skeleton width={46} height={46} className={styles.skIconBox} />
          <span className={styles.statText}>
            <Skeleton width="55%" height={13} />
            <Skeleton width={48} height={24} />
          </span>
        </div>
      ))}
    </div>

    <Card>
      <div className={styles.header}>
        <Skeleton width={140} height={26} />
        <div className={styles.search}>
          <Skeleton width="100%" height={44} className={styles.skRounded} />
        </div>
      </div>

      <div className={styles.tableWrap}>
        <div className={styles.tableHead}>
          <Skeleton width={60} height={13} />
          <Skeleton width={90} height={13} />
          <Skeleton width={60} height={13} />
          <Skeleton width={50} height={13} />
          <Skeleton width={60} height={13} />
        </div>
        <div className={styles.tableBody}>
          {Array.from({ length: 7 }).map((_, i) => (
            <div key={i} className={styles.row}>
              <Skeleton width="70%" height={14} />
              <Skeleton width="85%" height={14} />
              <span className={styles.center}>
                <Skeleton width={84} height={24} className={styles.skRounded} />
              </span>
              <span className={styles.center}>
                <Skeleton width={36} height={14} />
              </span>
              <span className={styles.center}>
                <Skeleton width={70} height={30} className={styles.skRounded} />
              </span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  </div>
);

export default UsersSkeleton;
